import { MatSnackBar } from '@angular/material/snack-bar';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/snack-bar";
export class ToastService {
    constructor(snackBar) {
        this.snackBar = snackBar;
        this.baseConfig = {
            duration: 5000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['toast-notification']
        };
    }
    success(message, config) {
        this.open(message, 'success', config);
    }
    error(message, config) {
        this.open(message, 'error', config);
    }
    alert(message, config) {
        this.open(message, 'alert', config);
    }
    open(message, type, config) {
        const mergedConfig = Object.assign({}, this.baseConfig, config, { panelClass: [
                ...(this.baseConfig.panelClass || []),
                `toast-${type}`,
                ...((config && config.panelClass) || [])
            ] });
        this.snackBar.open(message, '✕', mergedConfig);
    }
}
ToastService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ToastService_Factory() { return new ToastService(i0.ɵɵinject(i1.MatSnackBar)); }, token: ToastService, providedIn: "root" });
